import iconOne from '../../assets/service/1_1.webp';
import iconTwo from '../../assets/service/2.webp';
import iconThree from '../../assets/service/3.webp';
import iconFour from '../../assets/service/4.webp';

const ServicesData = [
    {
        icon: iconOne,
        key: 'dentalProsthetics'
    },
    {
        icon: iconTwo,
        key: 'aesthetics'
    },
    {
        icon: iconThree,
        key: 'prophylaxis'
    },
    {
        icon: iconFour,
        key: 'laserTherapy'
    }
];

export default ServicesData;